<template>
    <div v-if="Object.keys(services).length > 0">
        <div v-if="$props.visibleCertificate" class="col-md-12 mb-3">
            <div class="form-check form-switch">
                <input class="form-check-input cursor-pointer" type="checkbox" id="certificate" v-model="certificateEnabled">
                <label class="form-check-label cursor-pointer" for="certificate">Do you want to schedule certificates now?</label>
            </div>
        </div>
        <table class="table align-middle datatable w-100 ars">
            <thead>
                <tr>
                    <th
                        v-for="(service, index) in column"
                        :key="index"
                        class="small"
                        scope="col"
                    >{{ service }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(service, index) in services" :key="index">
                    <td
                        v-for="(item, itemIndex) in service"
                        :key="itemIndex"
                        class="small"
                    >
                        <BookingDatePicker
                            v-model="item.date"
                            :format="'dd-MM-yyyy'"
                            :time-picker="false"
                            :display-marker="false"
                            :disabled="!certificateEnabled"
                            :auto-apply="true"
                        ></BookingDatePicker>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import BookingDatePicker from "./BookingDatePicker";
export default {
    props: {
        orderData: {
            type: Object,
            required: true
        },
        visibleCertificate: {
            type: Boolean,
            default: true
        }
    },
    components: {
        BookingDatePicker
    },
    data() {
        return {
            column: {},
            services: [],
            order: {},
            certificateEnabled: true,
            isServiceModified: false
        }
    },
    mounted() {
        this.order = this.orderData.order || this.orderData;
        this.getRecurringServices();

        // Receive calendar date change
        this.$emitter.on('calendarDateSelected', (data) => {
            this.isServiceModified = true;
            this.updateRecurringServices();
        });
    },
    methods: {
        getRecurringServices() {
            axios.post('/admin/users/get-rs-with-address', {
                user_id: this.order.customer_id,
                address_id: this.order.address_id
            })
                .then(response => {
                    this.column = response.data.column;
                    this.services = response.data.services
                })
        },
        updateRecurringServices() {
            let self = this;
            axios.post('/admin/users/update-rs-with-address', {
                user_id: this.order.customer_id,
                address_id: this.order.address_id,
                services: this.services
            })
                .then(response => {
                    //self.$notification(
                    //    response.data.status,
                    //    response.data.message
                    //);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        serviceModified() {
            console.log('serviceModified');
        }
    },
    watch: {
        orderData: {
            deep: true,
            handler(oldVal, newVal) {
                this.getRecurringServices();
            }
        }
    }
}
</script>
<style>
.ars .dp__input {
    padding-right: 7px !important;
    margin-right: 10px !important;
}
</style>
